import React, { memo } from "react"

import { useAccount, useSchedule } from "../../../../../@shared/contexts"
import FreeContent from "./FreeContent"
import PaidContent from "./PaidContent"

export default memo(function Content() {
  const { schedule } = useSchedule()
  const { account } = useAccount()
  const isPaidAndPaidUser =
    schedule?.paymentInformation === "PAID" &&
    account.viewer?.role === "PAID_USER"

  if (!schedule?.paymentInformation) {
    return null
  }

  if (isPaidAndPaidUser) {
    return <PaidContent />
  }

  return <FreeContent />
})

export const ALL_TAB = ["녹화방송", "숏폼 / AI 요약"] as const
export type TabTuple = typeof ALL_TAB
export type Tab = TabTuple[number]
